<!-- <ul class="layout-menu" [ngClass]="{'disabled-menu': !userFound}">
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul> -->

<ul class="layout-menu" [ngClass]="{'disabled-menu': !userFound}">
    <ng-container *ngFor="let item of model; let i = index;" >
        <ng-container *ngIf="!item.separator">
            <li app-menuitem *ngIf="!hasVendorManagement(item)" [item]="item" [index]="i" [root]="true"></li>
        </ng-container>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>